// @flow

import * as React from 'react'
import { Grid, Segment, Button, Message, Label } from 'semantic-ui-react'
import { Form, formActions, Validators, Fields } from 'react-redux-components'
import { connect, type Connector } from 'react-redux'
import { getUsername } from './store/authentication'

import { updatePassword, type ChangePasswordForm as ChangePasswordFormType } from './store/authentication'
import logo from './CLARA.svg'
import type { ReduxState, Dispatch } from './store'

type OwnProps = {|
  title: string,
|}

type MappedProps = {|
  username: string,
  status: string,
  error: Object,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    username: getUsername(state),
    status: state.auth.data.status,
    error: state.auth.data.error,
  }
}

type Field = {|
  value: string,
|}
type FormValues = {
  oldPassword: Field,
  newPassword: Field,
  newPasswordConfirm: Field,
}

type Props = { dispatch: Dispatch } & MappedProps & OwnProps

class ChangePasswordForm extends React.Component<Props> {
  static defaultProps = {
    title: 'Cambio password',
  }

  oldPassword: ?HTMLInputElement

  validators = {
    oldPassword: { required: Validators.required },
    newPassword: { required: Validators.required },
    newPasswordConfirm: { required: Validators.required },
    '': {
      matchPassword: (vals: FormValues): boolean => {
        return vals.newPassword.value === vals.newPasswordConfirm.value
      },
      differentNewPassword: (vals: FormValues): boolean => {
        return vals.oldPassword.value !== vals.newPassword.value
      },
      passwordLength: (vals: FormValues): boolean => {
        return /(?=^.{8,}$).*$/.test(vals.newPassword.value)
      },
      strongPassword: (vals: FormValues): boolean => {
        return /(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).*$/.test(vals.newPassword.value)
      },
    },
  }

  componentDidMount() {
    this.props.dispatch(formActions.reset('auth.changePassForm'))
    if (this.oldPassword) this.oldPassword.focus()
  }

  handleFormOnSubmit = (values: ChangePasswordFormType) => {
    this.props.dispatch(updatePassword(this.props.username, values))
  }

  render() {
    return (
      <div>
        <Grid verticalAlign={'middle'} centered={true}>
          <div className="ui row" style={{ height: '96vh' }}>
            <div className="six wide column">
              <Segment>
                <Label attached="top" color="orange" size="big">
                  {this.props.title}
                </Label>
                <Grid verticalAlign={'middle'} centered={true} style={{ marginBottom: '5ex' }}>
                  <div className="ui row">
                    <div className="seven wide column" style={{ textAlign: 'center' }}>
                      <img src={logo} alt="CLARA logo" />
                    </div>
                    <div className="nine wide column">
                      <div style={{ height: '2ex' }} />
                      <Form
                        model="auth.changePassForm"
                        className="ui form center"
                        onSubmit={this.handleFormOnSubmit}
                        validators={this.validators}>
                        <Fields.PasswordInput
                          label="Vecchia password"
                          model=".oldPassword"
                          errorMessages={{
                            required: 'Campo obbligatorio.',
                          }}
                          rawField={(field: HTMLInputElement) => {
                            this.oldPassword = field
                          }}
                        />
                        <Fields.PasswordInput
                          label="Nuova password"
                          model=".newPassword"
                          errorMessages={{
                            required: 'Campo obbligatorio.',
                          }}
                        />
                        <Fields.PasswordInput
                          label="Conferma password"
                          model=".newPasswordConfirm"
                          errorMessages={{
                            required: 'Campo obbligatorio.',
                          }}
                        />
                        <Button
                          color="orange"
                          loading={this.props.status === 'UPDATE_PASSWORD_PENDING'}
                          type="submit"
                          className="fluid large ">
                          Invio
                        </Button>
                        <Fields.Errors
                          model="auth.changePassForm"
                          wrapper={props => {
                            return (
                              <Message size="mini" negative>
                                <ul style={{ paddingLeft: '1ex' }}>{props.children}</ul>
                              </Message>
                            )
                          }}
                          component="li"
                          messages={{
                            differentNewPassword: 'Specificare una password diversa dalla precedente',
                            matchPassword: 'Le password inserite non corrispondono',
                            passwordLength: 'La nuova password deve essere lunga almeno 8 caratteri',
                            strongPassword: 'La nuova password deve contenere una maiuscola, una minusola e un numero',
                          }}
                        />
                      </Form>
                    </div>
                  </div>
                  <div className="ui row" style={{ padding: 0 }}>
                    <div className="column">
                      <Message
                        style={{ marginBottom: '1rem' }}
                        hidden={this.props.status !== 'UPDATE_PASSWORD_ERROR' && this.props.status !== 'TOKEN_EXPIRED'}
                        negative>
                        <Message.Header>{this.props.error.title}</Message.Header>
                        <p>{this.props.error.message}</p>
                      </Message>
                    </div>
                  </div>
                </Grid>
                <Label className="brand" attached="bottom" centered={true} size="small">
                  <b className="brand-cap">C</b>hannel <b className="brand-cap">L</b>eads <b className="brand-cap">A</b>ctivity
                  & <b className="brand-cap">R</b>eport <b className="brand-cap">A</b>ssistant
                </Label>
              </Segment>
            </div>
          </div>
        </Grid>
      </div>
    )
  }
}
const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(ChangePasswordForm)



// WEBPACK FOOTER //
// ./src/change-password-form.js